import type { VFC } from 'react';

import capitalize from 'lodash/capitalize';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import {
  formatAssetUpcomingDate,
  isUpcomingLive,
} from '../../../../shared/helpers/assetHelpers';
import { Badge } from '../Badge/Badge';
import { useServerTime } from '../../../utils/useServerTime';

interface UpcomingLiveBadgeProps {
  asset: SvpAssetAdditional;
}

const UpcomingLiveBadge: VFC<UpcomingLiveBadgeProps> = ({ asset }) => {
  const { serverTime } = useServerTime();

  const upcomingLabel = isUpcomingLive(asset, serverTime)
    ? formatAssetUpcomingDate(asset)
    : undefined;

  return upcomingLabel ? <Badge label={capitalize(upcomingLabel)} /> : null;
};

export { UpcomingLiveBadge };
